import React from 'react';
import * as S from '../styles';
import { ActionItem, Card } from '../../../@types/domain';
import { HostPlatform } from '../../../config/hostPlatform';
import { BsTrash } from 'react-icons/bs';
import { useRemoveActivityItemMutation } from './hooks';

type WorkItemProperties = {
  id: string;
  allowEdit?: boolean;
  allowRemove?: boolean;
  item: ActionItem;
  card: Card;
  index: number;
  onClick?: () => void | undefined | Promise<void>;
};

const WorkItem = ({
  id,
  item: { disabled, icon, text },
  card,
  index,
  allowRemove,
  allowEdit,
  onClick,
}: WorkItemProperties) => {
  const isMonday = HostPlatform.isMonday();

  const { mutateAsync: removeActionItem, isLoading: isRemovingActionItem } =
    useRemoveActivityItemMutation(card);
  function handleDeleteClick(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    event.stopPropagation();
    return removeActionItem(index);
  }

  return (
    <S.ActivityItem
      onClick={disabled || !allowEdit ? undefined : onClick}
      disabled={disabled}
    >
      {icon && (
        <S.ActionItemIcon>
          <S.TriggerDropdownIcon src={icon.iconUrl} title={icon.name} />
        </S.ActionItemIcon>
      )}
      {isMonday && (
        <S.ActionItemIcon>
          <S.MondayIcon />
        </S.ActionItemIcon>
      )}

      <S.ActivityLabel disabled={disabled} hasIcon={icon} textNote={isMonday}>
        {(HostPlatform.isJira() || HostPlatform.isAzure()) && (
          <S.WorkItemId>{id}</S.WorkItemId>
        )}
        {text}
      </S.ActivityLabel>

      {allowRemove && (
        <S.ActivityLinkButton
          type="button"
          disabled={disabled || isRemovingActionItem}
          onClick={handleDeleteClick}
          width="30px"
          right="0"
        >
          <BsTrash />
        </S.ActivityLinkButton>
      )}
    </S.ActivityItem>
  );
};

export default WorkItem;
